// SlicePlugin definition for the rectangle slice (PRD-F1 §TR5, §T12).
//
// Migrated to the discriminated-union CapabilityDescriptor form (PRD-X §TR3).
// Diverges from the sticky slice by omitting all text-related capabilities
// (text-content, rich-edit, font-size, font-style) and adds 'border-style'
// (dual aspect) plus 'rotation' (edit-only) per P5.1. isAnchorTarget always
// returns true per ND1.

import type { SlicePlugin } from '../../core/object-registry.js';
import {
  type CapabilityDescriptor,
  BORDER_STYLE_VIEW,
  BORDER_STYLE_EDIT,
  ANCHOR_TARGET_VIEW,
  RESIZE_EDIT,
  ROTATION_EDIT,
  BG_COLOR_VIEW,
  BG_COLOR_EDIT,
  STACK_PRESENCE_VIEW,
  UPDATABLE_PROPERTIES_EDIT,
} from '../../core/capabilities/capability.interface.js';
import type { RectangleObject } from './rectangle.interface.js';
import { createRectangleDefaults } from './rectangle-defaults.factory.js';
import { createNode, updateNode } from './rectangle.renderer.js';

const RECTANGLE_CAPABILITIES: readonly CapabilityDescriptor[] = [
  { capability: 'border-style', view: BORDER_STYLE_VIEW, edit: BORDER_STYLE_EDIT },
  { capability: 'anchor-target', view: ANCHOR_TARGET_VIEW },
  { capability: 'resize', edit: RESIZE_EDIT },
  { capability: 'rotation', edit: ROTATION_EDIT },
  { capability: 'background-color', view: BG_COLOR_VIEW, edit: BG_COLOR_EDIT },
  { capability: 'stack-presence', view: STACK_PRESENCE_VIEW },
  { capability: 'updatable-properties', edit: UPDATABLE_PROPERTIES_EDIT },
];

export const rectangleSlice: SlicePlugin<RectangleObject> = {
  type: 'rectangle',
  role: 'primary',
  capabilities: RECTANGLE_CAPABILITIES,
  display: {
    iconUrl: 'fa-square',
    label: 'Rechteck',
  },
  createDefaults: createRectangleDefaults,
  createNode,
  updateNode,
  isAnchorTarget: () => true,
};
